import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button, Spin, Modal } from 'antd';
import FormatePrice from '../../utils/FormatePrice';
import PropertyCallingButton from '../../utils/PropertyCardCall';
import PropertyWhatsAppButton from '../../utils/PropertyCardWhatsApp';
import GetInTouch from '../../utils/getInTouch';
import BuildingType from "../../JsonData/BuildingType.json"
import PropertyDetails from "../../JsonData/property-details.json"
import { useParams } from 'react-router-dom';
import { slugify } from '../../utils/slugify';
import BrochureDownload from '../../utils/BrochureDownload';

const PropertyCard = ({ property }) => {
    const {
        PropertyName,
        locality,
        price,
        property_type,
        building_type,
        construction_type,
        number_bedroom,
        number_bathroom,
        plot_area,
        carpet_area,
        builtup_area,
        furnish_type,
        CompletionStatus,
        name,
        bhk_type,
        id,

    } = property;

    const [open, setOpen] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);


    const showModal = () => setOpen(true);
    const handleCancel = () => setOpen(false);


    return (
        <div className="col-lg-4 col-md-6 mb-4">
            <div className="single-feature">
                <div className="thumb position-relative">
                    <Button
                        className="position-absolute"
                        style={{
                            top: '10px',
                            right: '10px',
                            zIndex: 2,
                            padding: '6px 12px',
                            fontSize: '14px',
                            borderRadius: '5px',
                            width: "150px",
                            color: "#FDA94F"
                        }}
                        onClick={showModal}
                    >
                        Enquire Now
                    </Button>
                    <img
                        src={property.images && property.images.length > 0 ? property.images[0].src : "default-image-path.jpg"}
                        alt="Property"
                        className="img-fluid property-image"
                        style={{
                            height: '250px',
                            width: '100%',
                            objectFit: 'cover',
                        }}
                    />
                </div>

                <div className="details">
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingBottom: "15px",
                        flexDirection: "row",
                        flexWrap: "wrap"
                    }}>
                        <h6 className="price">{FormatePrice(price)} AED</h6>

                        <BrochureDownload download_link={property.Brochure} />
                    </div>



                    <h6 className="title readeal-top">
                        <Link
                        //to={item.url}
                        >{PropertyName}</Link>
                    </h6>
                    <h6 className="title readeal-top" style={{ fontSize: "12px" }}>
                        <i className="fa fa-home" style={{ color: "orange", fontSize: "15px" }}></i>
                        <Link
                        //   to={item.url}
                        > {building_type}</Link>
                    </h6>
                    {/* <h6 className="location">
                        <i className="fa fa-map-marker" style={{ color: "orange", marginRight: "5px" }} />
                        {locality}
                    </h6> */}
                    <p className="location"><i className="fa fa-map-marker" style={{ marginRight: '5px', color: "orange " }} />
                        {locality}</p>

                    <ul className="info-list">
                        <li><i className="fa fa-bed" /> {number_bedroom}</li>
                        {/* <li><i className="fa fa-bath" /> {number_bathroom}</li> */}
                        <li><img src="/assets/img/icons/7.png" alt="area" /> {builtup_area} sq ft</li>
                    </ul>

                    <ul className="contact-list">
                        <li className="readeal-top">
                            <Link className="btn btn-yellow" to={`/property-details/${slugify(PropertyName)}`}>View Details</Link>
                        </li>
                        <li><PropertyCallingButton /></li>
                        <li><PropertyWhatsAppButton /></li>
                    </ul>
                </div>
            </div>

            <Modal
                title=""
                open={open}
                onCancel={handleCancel}
                footer={null}
                maskStyle={{ backgroundColor: 'transparent' }}
                maskClosable={false}
            >
                <GetInTouch onClose={handleCancel} property={selectedProperty} />
            </Modal>
        </div>


    );
};

export default PropertyCard;